import ReelSymbol from '@Core/Reels/ReelSymbol';
import { ISpinOutcome } from '@GFTypes/GameStoreTypes';
import { ExpandingSymbol } from './ExpandingSymbol';
import { EExpandingSymbolAnimations } from './ExpandingSymbolAnimations';
import { Point } from 'pixi.js';

export interface SymbolExpansionStrategy {
    symbolIds: number[];
    getWinningExpandingSymbols(outcome: ISpinOutcome): ISymbolInfo[];
    getInitialExpandingSymbols(loopWinAnimation?: boolean, showOnlyHighestMultiplier?: boolean): ExpandingSymbol[];
    getExpandingAnimationName(expandingSymbol: ExpandingSymbol): string;
    getSpinePosition(expandingSymbol: ExpandingSymbol, visibleSymbols: ReelSymbol[][]): Point;
    getAnimationVariant(animation: EExpandingSymbolAnimations, expandingSymbol: ExpandingSymbol): string;
}

export interface ISymbolInfo {
    positionOnReel: IPositionOnReels;
    symbolId: number;
}

export interface IPositionOnReels {
    reelIndex: number;
    visibleSymbolIndex: number;
}

export enum EExpandingMode {
    SEQUENTIAL = 'SEQUENTIAL',
    SIMULTANEOUS = 'SIMULTANEOUS',
    DELAYED = 'DELAYED'
}

export enum EExpandingSkippingMode {
    SINGLE = 'SINGLE',
    ALL = 'ALL'
}
